"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeaconGlobalStyle = void 0;

var _styledComponents = require("styled-components");

var BeaconGlobalStyle = (0, _styledComponents.createGlobalStyle)(["button{font-family:inherit;font-size:inherit;line-height:inherit;text-transform:inherit;overflow:visible;border:0;margin:0;padding:0;background:transparent;&:focus{outline:0;}}"]);
exports.BeaconGlobalStyle = BeaconGlobalStyle;